import { ShippingMethod } from "inbounds/ShippingMethod";

export const getIsLtlExternal = (shippingMethod?: ShippingMethod): boolean =>
  Boolean(shippingMethod === ShippingMethod.LTL_EXTERNAL);
